import * as t from "react";
const r = (e) => /* @__PURE__ */ t.createElement("svg", { width: 16, height: 9, viewBox: "0 0 16 9", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M0 9.00001H15.3103L9.8456 1.86144C8.7415 0.419071 6.5689 0.419071 5.4647 1.86144L0 9.00001Z" }));
export {
  r as default
};
//# sourceMappingURL=arrow.svg.js.map
